// Conteúdo por nicho — Evolzap landing page
// Cada nicho segue o mesmo schema: slug, nome, icone, hero, multichannel, planos, faq, ivo

const ctaPrimarioPadrao = "Falar no WhatsApp";
const ctaSecundarioPadrao = "Ver planos";

export const PLANOS_PADRAO = [
  {
    id: "gratuito",
    nome: "Gratuito",
    preco: 0,
    descricao: "Pra conhecer a plataforma",
    destaque: false,
    badge: null,
    incluso: [
      { texto: "Mensagens ilimitadas", icone: "Check" },
      { texto: "1 canal (WhatsApp)", icone: "Layers" },
      { texto: "2 usuários", icone: "Users" },
      { texto: "Cadastros com limitações (produtos, serviços, insumos)", icone: "Briefcase" },
      { texto: "Campanhas e agendamentos limitados", icone: "Rocket" },
      { texto: "Automação / IA", icone: "Sparkles" },
      { texto: "API oficial (consulte regras de uso)", icone: "Zap" },
      { texto: "Recursos do seu nicho com limitações", icone: "Zap" },
      { texto: "Ivo — IA de gestão", icone: "Bot", disponivel: false },
      { texto: "Multicanal (Telegram, Facebook, Instagram)", icone: "Layers", disponivel: false },
      { texto: "Sistema VoIP", icone: "Phone", disponivel: false },
    ],
    cta: "Começar grátis",
    ctaHref: "https://evolzap.shop",
    notaRodape: null,
  },
  {
    id: "start",
    nome: "Start",
    preco: 99.9,
    descricao: "Pra começar a operar com profissionalismo",
    destaque: true,
    badge: "MAIS POPULAR",
    incluso: [
      { texto: "Mensagens ilimitadas", icone: "Check" },
      { texto: "5 instâncias por canal (WhatsApp, Telegram, Facebook, Instagram, Webchat)", icone: "Layers" },
      { texto: "10 usuários", icone: "Users" },
      { texto: "Produtos ilimitados", icone: "Briefcase" },
      { texto: "20 automações / IA", icone: "Sparkles" },
      { texto: "Ivo — sua IA de gestão", icone: "Bot", destaque: true },
      { texto: "Prospecção, campanhas e e-mail marketing", icone: "Rocket" },
      { texto: "Sistema VoIP", icone: "Phone" },
      { texto: "API oficial (consulte regras de uso)", icone: "Zap" },
      { texto: "CRM completo", icone: "Briefcase" },
      { texto: "Todos os recursos do seu nicho", icone: "Zap" },
    ],
    cta: "Começar agora",
    ctaHref: "https://evolzap.shop",
    notaRodape: null,
  },
  {
    id: "pro",
    nome: "Pro",
    preco: 249.9,
    descricao: "Pra equipes que querem escalar",
    destaque: false,
    badge: null,
    incluso: [
      { texto: "Mensagens ilimitadas", icone: "Check" },
      { texto: "15 instâncias por canal (WhatsApp, Telegram, Facebook, Instagram, Webchat)", icone: "Layers" },
      { texto: "30 usuários", icone: "Users" },
      { texto: "Produtos ilimitados", icone: "Briefcase" },
      { texto: "100 automações / IA", icone: "Sparkles" },
      { texto: "Ivo — sua IA de gestão", icone: "Bot", destaque: true },
      { texto: "Prospecção, campanhas e e-mail marketing", icone: "Rocket" },
      { texto: "Sistema VoIP", icone: "Phone" },
      { texto: "API oficial (consulte regras de uso)", icone: "Zap" },
      { texto: "CRM completo", icone: "Briefcase" },
      { texto: "Todos os recursos do seu nicho", icone: "Zap" },
    ],
    cta: "Começar agora",
    ctaHref: "https://evolzap.shop",
    notaRodape: null,
  },
];

export const conteudoPorNicho = {
  isp_provedor: {
    slug: "isp_provedor",
    nome: "ISP / Provedor de Internet",
    icone: "Wifi",
    hero: {
      badge: "Para provedores de internet",
      titulo: "Seu provedor com cliente em dia, suporte rápido e cobrança automática",
      subtitulo:
        "Gestão de clientes, mensalidades, boletos automáticos e suporte técnico via WhatsApp. Seu ISP profissional de verdade.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho um provedor de internet e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Suporte por chat e voz no mesmo painel — sem softphone separado",
      subtitulo:
        "Cliente liga reclamando, outro abre chamado no WhatsApp, equipe técnica responde tudo numa só tela. VoIP integrado, sem custo extra de softphone.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Integra com qual sistema de gestão?",
        resposta:
          "Integração com IXC, MK-Auth, Voalle e outros via API. Pergunta a gente sobre seu sistema atual.",
      },
      {
        pergunta: "Tem como gerar boleto bancário?",
        resposta:
          "Sim. Integração com bancos principais — Itaú, Bradesco, Sicoob, Sicredi e mais.",
      },
      {
        pergunta: "Funciona pra provedor pequeno?",
        resposta:
          "Sim. A partir de 50 clientes já compensa. Plano cresce com seu provedor.",
      },
      {
        pergunta: "Tem app pro técnico em campo?",
        resposta:
          "Sim. Técnico vê chamados, atualiza status e fecha OS pelo celular.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Recebimento de hoje" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "R$ 8.420 de 47 boletos pagos. Faltam 23 cair (R$ 4.180). 8 atrasados há +5 dias.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Inadimplência por faixa",
          labels: ["1-5d", "6-15d", "16-30d", "+30d"],
          valores: [8, 5, 3, 2],
          destaque: "18 inadimplentes",
        },
        { autor: "dono", tipo: "audio", duracao: "0:05" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Cobrança disparada pros 8 atrasados. 3 já visualizaram.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:14" },
      ],
    },
  },

  profissional_autonomo: {
    slug: "profissional_autonomo",
    nome: "Profissional Autônomo",
    icone: "Briefcase",
    hero: {
      badge: "Para quem trabalha por conta",
      titulo:
        "Organize sua agenda, cobre sem vergonha e nunca mais perca cliente",
      subtitulo:
        "Agenda, cobrança e WhatsApp organizados. Pra você focar no que faz de melhor, não em planilha.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Sou profissional autônomo e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Cliente liga, manda no WhatsApp, comenta no Insta? Atenda tudo num lugar só",
      subtitulo:
        "Profissional ocupado não tem tempo de ficar trocando de aplicativo. Centralize todos os contatos numa única tela e nunca mais perca cliente.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona pra qualquer profissão?",
        resposta:
          "Sim. Personal, psicólogo, advogado, designer, manicure, nutricionista — qualquer profissional que atende cliente por hora ou serviço.",
      },
      {
        pergunta: "Preciso de CNPJ?",
        resposta:
          "Não. Funciona pra MEI, autônomo sem CNPJ, ou empresa. Você usa do jeito que quiser.",
      },
      {
        pergunta: "E se eu não souber mexer com sistema?",
        resposta:
          "A gente faz a configuração inicial pra você. Em 30 minutos está tudo rodando.",
      },
      {
        pergunta: "Meu cliente precisa baixar app?",
        resposta: "Não. Tudo no WhatsApp que ele já usa.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Como tá meu mês?" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "R$ 8.420 recebidos em 32 atendimentos. Comparado ao mês passado, +18%.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Receita semanal",
          labels: ["S1", "S2", "S3", "S4"],
          valores: [1800, 2100, 1900, 2620],
          destaque: "R$ 8.420",
        },
        {
          autor: "dono",
          tipo: "texto",
          conteudo: "Manda áudio com plano de ação",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:18" },
      ],
    },
  },

  pizzaria: {
    slug: "pizzaria",
    nome: "Pizzaria / Delivery",
    icone: "Pizza",
    hero: {
      badge: "Para pizzarias e deliveries",
      titulo:
        "Pedido pelo WhatsApp, impresso na cozinha e entregue no prazo",
      subtitulo:
        "Cardápio digital, pedidos automáticos, controle de entregadores e impressão direta. Sua pizzaria rodando no automático.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho uma pizzaria/delivery e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Pedido por ligação, WhatsApp ou Instagram cai na mesma tela",
      subtitulo:
        "Cliente prefere ligar? Atendente vê o pedido aparecer junto com os do WhatsApp. Sem trocar de tela, sem perder pedido, sem confusão na cozinha.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona com qual impressora?",
        resposta:
          "Funciona com qualquer impressora térmica de 80mm — Bematech, Epson, Elgin, Daruma. A gente configura pra você.",
      },
      {
        pergunta: "Aceita cartão e Pix?",
        resposta:
          "Sim. Pagamento pelo cartão, Pix, dinheiro na entrega — tudo configurável.",
      },
      {
        pergunta: "Tem app pro entregador?",
        resposta:
          "Sim. Cada entregador acessa pelo celular dele e vê só as entregas atribuídas.",
      },
      {
        pergunta: "Funciona em mais de uma loja?",
        resposta:
          "Sim. Plano específico pra rede com várias unidades — fala com a gente.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "audio", duracao: "0:06" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Hoje saíram 87 pizzas, R$ 4.190 de receita. Calabresa lidera com 22 vendas.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Pizzas mais vendidas",
          labels: ["Calab.", "Marg.", "Port.", "Frango", "Mussa."],
          valores: [22, 18, 14, 12, 9],
          destaque: "Top 5 do dia",
        },
        { autor: "dono", tipo: "texto", conteudo: "Tô ficando sem mussarela?" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Estoque em 4kg, dá pra ~30 pizzas. Recomendo pedir hoje.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:14" },
      ],
    },
  },

  assistencia_tecnica: {
    slug: "assistencia_tecnica",
    nome: "Assistência Técnica",
    icone: "Wrench",
    hero: {
      badge: "Para assistências técnicas",
      titulo:
        "Cliente sabendo o status do conserto sem ligar toda hora",
      subtitulo:
        "OS digital, atualização automática de status e cobrança fácil. Sua assistência mais profissional do que nunca.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho uma assistência técnica e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Atenda cliente por WhatsApp ou ligação no mesmo painel",
      subtitulo:
        "Cliente liga pra saber do conserto enquanto outro manda mensagem? Atenda os dois sem alternar app. Histórico completo da conversa, independente do canal.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona pra qual tipo de assistência?",
        resposta:
          "Celular, notebook, eletrodoméstico, eletrônica em geral. Qualquer assistência que recebe aparelho pra consertar.",
      },
      {
        pergunta: "Tem como anexar foto na OS?",
        resposta:
          "Sim. Foto antes do reparo, durante e depois. Tudo arquivado por OS.",
      },
      {
        pergunta: "Cliente recebe nota fiscal?",
        resposta:
          "Sim, integrado com emissor de NF-e e NFS-e. Pergunta a gente sobre integração.",
      },
      {
        pergunta: "Funciona com mais de um técnico?",
        resposta:
          "Sim. Cada técnico tem login próprio e vê só as OS atribuídas.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Como tá o fluxo de OS?" },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "OS por status",
          labels: ["Diag.", "Reparo", "Pronto", "Entreg."],
          valores: [8, 14, 12, 23],
          destaque: "57 OS ativas",
        },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "12 aparelhos prontos pra entrega. 4 estão há +7 dias esperando o cliente buscar.",
        },
        { autor: "dono", tipo: "audio", duracao: "0:05" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Feito. Lembrete enviado pros 4 clientes com valor a pagar.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:11" },
      ],
    },
  },

  lava_jato: {
    slug: "lava_jato",
    nome: "Lava Jato",
    icone: "Car",
    hero: {
      badge: "Para lava jatos",
      titulo:
        "Fila organizada, cliente avisado e dinheiro no caixa no fim do dia",
      subtitulo:
        "Cadastro de cliente, ordem de serviço simples e controle de fila. Sem complicação, do jeito que lava jato precisa.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho um lava jato e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "WhatsApp, Instagram ou ligação? Atenda tudo numa tela só",
      subtitulo:
        "Cliente fiel liga pra agendar? Outro manda no WhatsApp? Sua equipe atende ambos no mesmo painel, sem confusão.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Preciso de computador?",
        resposta:
          "Não. Funciona no celular, tablet ou computador. O que você tiver.",
      },
      {
        pergunta: "Funciona com mais de um funcionário?",
        resposta:
          "Sim. Cada um tem login próprio e você vê quanto cada um produziu.",
      },
      {
        pergunta: "Tem como dar desconto pra cliente fiel?",
        resposta:
          "Sim. Programa de fidelidade automático: 10ª lavagem grátis ou desconto progressivo.",
      },
      {
        pergunta: "Cliente precisa baixar app?",
        resposta: "Não. Tudo pelo WhatsApp normal.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Resumo da semana" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "142 lavagens, R$ 5.680 de receita. Sábado foi o pico com 38 carros.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Lavagens por dia",
          labels: ["S", "T", "Q", "Q", "S", "S", "D"],
          valores: [12, 16, 14, 18, 22, 38, 22],
          destaque: "+24% vs semana anterior",
        },
        { autor: "dono", tipo: "audio", duracao: "0:07" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "5 clientes do plano mensal não vieram. Lembrete disparado pra todos.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:16" },
      ],
    },
  },

  vestuario: {
    slug: "vestuario",
    nome: "Vestuário e Calçados",
    icone: "ShoppingBag",
    hero: {
      badge: "Para lojas de roupa e calçado",
      titulo:
        "Sua loja vendendo pelo WhatsApp como uma loja online",
      subtitulo:
        "Catálogo digital, controle de estoque, vendas e fidelidade. Sua loja física com poder de e-commerce.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho uma loja de vestuário/calçados e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Cliente do Insta, do WhatsApp e do telefone — tudo numa só tela",
      subtitulo:
        "Comentário no Instagram, mensagem no WhatsApp e ligação caem no mesmo painel. Sua loja vendendo em todos os canais sem perder o controle.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Tem como importar meu catálogo?",
        resposta:
          "Sim. Importação em planilha Excel ou CSV. A gente te ajuda no primeiro upload.",
      },
      {
        pergunta: "Aceita cartão e Pix?",
        resposta:
          "Sim. Pagamento pelo cartão, Pix e até parcelado.",
      },
      {
        pergunta: "Funciona em mais de uma loja?",
        resposta:
          "Sim. Plano específico pra rede com várias unidades.",
      },
      {
        pergunta: "Tem como criar promoção relâmpago?",
        resposta:
          "Sim. Cria cupom e envia pra base de clientes em 1 clique.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Top vendas da semana" },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Produtos mais vendidos",
          labels: ["Tênis 32", "Camisa P", "Calça 42", "Vestido M", "Bolsa"],
          valores: [18, 14, 12, 9, 7],
          destaque: "R$ 12.840 em vendas",
        },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Tênis branco modelo 32 lidera com 18 unidades. Restam 7 no estoque.",
        },
        { autor: "dono", tipo: "texto", conteudo: "Quem comprou e sumiu?" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "47 clientes sem compra há +60 dias. Posso disparar cupom de retorno?",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:13" },
      ],
    },
  },

  barbearia: {
    slug: "barbearia",
    nome: "Barbearia",
    icone: "Scissors",
    hero: {
      badge: "Para barbearias modernas",
      titulo:
        "Sua barbearia lotada de cliente fiel, sem precisar correr atrás",
      subtitulo:
        "Agendamento online no WhatsApp, comanda digital e fidelidade automática. Tudo num sistema feito pra barbearia de verdade.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho uma barbearia e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Cliente prefere ligar? Atende no mesmo painel do WhatsApp",
      subtitulo:
        "Tem aquele cliente que sempre liga pra marcar? Agora ele cai na mesma tela das mensagens. Sem trocar de app, sem perder horário.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Preciso de cartão pra começar?",
        resposta:
          "Não. Você cria sua conta e começa no plano Gratuito, sem cartão. Só paga se quiser desbloquear mais recursos nos planos pagos.",
      },
      {
        pergunta: "Funciona com mais de um barbeiro?",
        resposta:
          "Sim. Você cadastra todos os barbeiros, cada um vê só os agendamentos dele e a comissão é calculada automaticamente.",
      },
      {
        pergunta: "Meu cliente precisa baixar app?",
        resposta:
          "Não. Tudo acontece no WhatsApp normal que ele já usa.",
      },
      {
        pergunta: "E se eu já tiver agenda em outro lugar?",
        resposta:
          "A gente ajuda você a migrar os clientes e horários. Em 1 dia já está tudo no Evolzap.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade. Cancela e pronto.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "audio", duracao: "0:04" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "R$ 1.240 de receita até agora, 18 atendimentos. Comissão do João já em R$ 320.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Atendimentos por barbeiro",
          labels: ["João", "Pedro", "Lucas", "Bruno"],
          valores: [12, 8, 5, 3],
          destaque: "Comissão hoje: R$ 580",
        },
        {
          autor: "dono",
          tipo: "texto",
          conteudo: "Quem não veio essa semana?",
        },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "4 clientes com agenda recorrente faltaram. Quer mandar reagendamento?",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:12" },
      ],
    },
  },

  salao_beleza: {
    slug: "salao_beleza",
    nome: "Salão de Beleza",
    icone: "Sparkles",
    hero: {
      badge: "Para salões de beleza",
      titulo:
        "Seu salão cheio, comissão certa e cliente sempre voltando",
      subtitulo:
        "Agendamento online, ficha do cliente, comissão automática e controle financeiro. O salão completo no celular.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho um salão de beleza e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "WhatsApp, Instagram e ligação no mesmo painel da equipe",
      subtitulo:
        "Cliente comenta no Instagram, manda mensagem no WhatsApp ou liga? Sua recepcionista atende tudo num lugar só, com histórico completo.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona com várias profissionais?",
        resposta:
          "Sim. Cada profissional tem login próprio, vê só os agendamentos dela e a comissão é calculada automaticamente.",
      },
      {
        pergunta: "Tem ficha técnica do cliente?",
        resposta:
          "Sim. Histórico completo, fórmulas usadas, fotos antes/depois, observações.",
      },
      {
        pergunta: "E se a profissional não souber mexer?",
        resposta:
          "Tela super simples, feita pra qualquer profissional usar pelo celular.",
      },
      {
        pergunta: "Aceita pagamento online?",
        resposta:
          "Sim. Pix, cartão, parcelado. Cliente paga antes ou na hora do serviço.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Resumo do dia" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "R$ 1.890 em 14 atendimentos. Maria liderou com 6 clientes.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Comissão por profissional",
          labels: ["Maria", "Ana", "Júlia", "Carla"],
          valores: [720, 480, 360, 330],
          destaque: "Total: R$ 1.890",
        },
        { autor: "dono", tipo: "audio", duracao: "0:06" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "23 clientes inativas há +60 dias. Promo de retorno disparada.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:15" },
      ],
    },
  },

  mercadinho: {
    slug: "mercadinho",
    nome: "Mercadinho / Hortifruti",
    icone: "ShoppingCart",
    hero: {
      badge: "Para mercadinhos e hortifrutis",
      titulo:
        "Pedido pelo WhatsApp, estoque controlado e entrega organizada",
      subtitulo:
        "PDV, controle de estoque, pedidos por WhatsApp e gestão de entregas. Seu mercadinho competindo com o grande.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho um mercadinho/hortifruti e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Pedido por ligação ou WhatsApp cai na mesma tela",
      subtitulo:
        "Cliente fiel ainda liga pra fazer pedido? Atendente recebe junto com os pedidos do WhatsApp, sem confusão e sem perder venda.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona com leitor de código de barras?",
        resposta:
          "Sim. Funciona com qualquer leitor USB ou bluetooth comum.",
      },
      {
        pergunta: "Aceita pagamento na entrega?",
        resposta:
          "Sim. Dinheiro, cartão na maquininha, Pix ou pago antes pelo WhatsApp.",
      },
      {
        pergunta: "Tem como controlar validade dos produtos?",
        resposta:
          "Sim. Aviso automático quando produto está perto de vencer.",
      },
      {
        pergunta: "Funciona em mais de uma loja?",
        resposta:
          "Sim. Plano específico pra rede com várias unidades.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "texto", conteudo: "Faturamento do dia" },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Vendas por categoria",
          labels: ["Hortif.", "Mer.", "Bebid.", "Limp.", "Padar."],
          valores: [2400, 1800, 1200, 840, 600],
          destaque: "R$ 6.840 hoje",
        },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "142 vendas, ticket médio R$ 48. Hortifruti puxando o resultado.",
        },
        { autor: "dono", tipo: "texto", conteudo: "O que tá vencendo?" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "12 produtos vencem em 3 dias. Sugiro promoção relâmpago — disparo agora?",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:17" },
      ],
    },
  },

  deposito_construcao: {
    slug: "deposito_construcao",
    nome: "Depósito de Construção",
    icone: "Hammer",
    hero: {
      badge: "Para depósitos de construção",
      titulo:
        "Orçamento na hora, vendas organizadas e cliente fidelizado",
      subtitulo:
        "Catálogo, orçamento rápido, vendas e cadastro de obras. Seu depósito vendendo mais e organizando menos.",
      ctaPrimario: ctaPrimarioPadrao,
      ctaSecundario: ctaSecundarioPadrao,
      mensagemWhatsapp:
        "Olá! Tenho um depósito de construção e quero saber mais sobre o Evolzap",
    },
    multichannel: {
      headline:
        "Pedreiro liga pra orçamento, cliente manda no WhatsApp — tudo num só lugar",
      subtitulo:
        "Sua equipe de vendas atende ligação e mensagem na mesma tela. Orçamento sai mais rápido, cliente não fica esperando.",
    },
    planos: PLANOS_PADRAO,
    faq: [
      {
        pergunta: "Funciona pra depósito pequeno?",
        resposta:
          "Sim. A partir de 1 funcionário já roda redondo. Sistema cresce com você.",
      },
      {
        pergunta: "Aceita venda a prazo?",
        resposta:
          "Sim. Cliente compra no fiado, sistema controla saldo e cobra automaticamente.",
      },
      {
        pergunta: "Tem app pra motorista de entrega?",
        resposta:
          "Sim. Motorista vê rota, confirma entrega com foto e assinatura.",
      },
      {
        pergunta: "Como funciona o orçamento?",
        resposta:
          "Você seleciona produtos, sistema gera PDF profissional e envia pelo WhatsApp em segundos.",
      },
      {
        pergunta: "Posso cancelar quando quiser?",
        resposta: "Pode. Sem multa, sem fidelidade.",
      },
    ],
    ivo: {
      conversa: [
        { autor: "dono", tipo: "audio", duracao: "0:08" },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "3 obras com saldo em aberto. Obra Silva lidera com R$ 12.400 há 22 dias.",
        },
        {
          autor: "ivo",
          tipo: "grafico",
          titulo: "Saldo por obra",
          labels: ["Silva", "Lima", "Souza"],
          valores: [12400, 6800, 3200],
          destaque: "Total: R$ 22.400",
        },
        {
          autor: "dono",
          tipo: "texto",
          conteudo: "Manda cobrança pro Silva",
        },
        {
          autor: "ivo",
          tipo: "texto",
          conteudo:
            "Cobrança com extrato e link Pix enviada. Tudo registrado no sistema.",
        },
        { autor: "ivo", tipo: "audio", duracao: "0:19" },
      ],
    },
  },
};

// Ordem de exibição no grid do modal (ISP primeiro)
export const nichosOrdenados = [
  "isp_provedor",
  "profissional_autonomo",
  "pizzaria",
  "assistencia_tecnica",
  "lava_jato",
  "vestuario",
  "barbearia",
  "salao_beleza",
  "mercadinho",
  "deposito_construcao",
];

export const WHATSAPP_NUMERO = "558520181255";
export const URL_SISTEMA = "https://app.evolzap.com/login";

export const buildWhatsappUrl = (mensagem) =>
  `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(mensagem)}`;
